import React, { Component } from 'react';
import { Container, Navbar, NavbarBrand, NavItem, Nav, NavDropdown} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import '../../localization/localizationService';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);
        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
        this.getServerVersionHeadline = () => {
                let name = sessionStorage.getItem("serverVersion");
                if (typeof (name) == "string" && name.length > 0)
                    return " (" + name + ")";
                else
                    return "";
            }
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    changeLanguage = (e) => {
        console.log(this.props)
        //this.props.changeLanguage(e)
        window.changeLanguage(e.target.dataset.language);
        this.forceUpdate();
    }

    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3">
                    <Container>
                        <NavbarBrand as={Link} to="/">FAEX Client <p className="server-environment">{this.getServerVersionHeadline()}</p></NavbarBrand>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <Nav.Link as={Link} className="text-dark" to="/">Dashboard</Nav.Link>
                            </NavItem>
                            {/*<NavItem>
                                <Nav.Link as={Link} className="text-dark" to="/">{window.i18n('profile')}</Nav.Link>
                            </NavItem>
                            <NavDropdown id="nav-dropdown" className="text-dark" title={window.i18n('changeLanguage')}>
                                <NavDropdown.Item data-language="de" onClick={this.changeLanguage}>Deutsch</NavDropdown.Item>
                                <NavDropdown.Item data-language="en" onClick={this.changeLanguage}>English</NavDropdown.Item>
                            </NavDropdown>*/}
                        </ul>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
